module.exports = __webpack_public_path__ + "img/wechatPay.2fed83fd.png";